import React, { useState, useContext, useEffect, useRef } from "react";
import axios from "axios";
import Header from ".././camponent/Header/Header";
import Topnavigation from ".././camponent/Topnavigation/Topnavigation";
import Herosection from ".././camponent/Herosection/Herosection";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Button from "react-bootstrap/Button";
import "./Dashboard.css";
import Select from "react-select";
import Profile from ".././camponent/Profile/Profile";
import { BsPlusLg, BsCalendar3 } from "react-icons/bs";
import Visa from "../../../Booking/assets/Images/social/visa.webp";
import Mastercard from "../../../Booking/assets/Images/social/mastercard.webp";
import Americanex from "../../../Booking/assets/Images/social/americanex.webp";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Profile2 from "../camponent/Profile/Profile2";
import { usePaymentInputs } from "react-payment-inputs";
import { LoginContext } from "../../LoginContext";
import { getpaymentMethod, updateStaxPaymentMethod } from "../../Api/dashboardApi";
import { deletepaymentmethod } from "../../Api/dashboardApi";

import { getstaffTime } from "../../Api/frontbooingApi";

import { getstaffApi } from "../../Api/dashboardApi";
import { cancelbookingbyid } from "../../Api/dashboardApi";
import { getUserBookingfront, rescheduleBooked } from "../../Api/dashboardApi";
import { getbookingstaff } from "../../Api/dashboardApi";
import { createPaymentMethod } from "../../Api/dashboardApi";
import { saverescheduledata } from "../../Api/dashboardApi";
import { getinvoiceApi } from "../../Api/dashboardApi";
import {
  payinvoiceApi,
  updatepaymentMethod,
  getdefaultpayment,
  checkTimeis24hours,
  getservertimzoneapi,
  postreview,
  sendEmailToSupportApi,
} from "../../Api/dashboardApi";
import { useConfirmModal } from "../../../hooks/useConfirmModal";
import CommonConfirmModal from "../../../Components/Modal/CommonConfirmModal";
import Spinner from "react-bootstrap/Spinner";
import { Roller } from "react-awesome-spinners";
import Badge from "react-bootstrap/Badge";
import moment from "moment";
import { BsStarFill, BsStar } from "react-icons/bs";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { DateRangePicker } from "react-date-range";
import LoadingSpinner from "./LoadingSpinner";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";

function Dashboard() {
  const confirmModal = useConfirmModal();
  const { LoggedInData, login, logout } = useContext(LoginContext);
  const [bookings, setBookings] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [staffList, setStaffList] = useState([]);

  const [orderid, setOrderId] = useState("");
  const [bookingAmount, setBookingAmount] = useState("");
  const [bookingStaffName, setBookingStaffName] = useState("");
  const [bookingdatetime, setBookingDateTime] = useState("");

  const { getExpiryDateProps } = usePaymentInputs();

  const [cardNumber, setCardNumber] = useState("");
  const [cardExpDate, setCardExpDate] = useState("");
  const [cardCVV, setCardCVV] = useState("");
  const [fullName, setFullName] = useState("");
  const [addCardValidate, setAddCardValidate] = useState(false);
  const [specialClientRequests, setSpecialClientRequests] = useState("");
  const [rescheduleBookingTime, setRescheduleBookingTime] = useState("");
  const [rescheduleClientNotes, setRescheduleClientNotes] = useState("");
  const [hasCats, setHasCats] = useState(false);
  const [hasDogs, setHasDogs] = useState(false);
  const [show, setShow] = useState(false);

  const [preferredTech, setPreferredTech] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show3, setShow3] = useState(false);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);

  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const [show5, setShow5] = useState(false);

  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);

  const [showText, setShowText] = useState(false);

  const [show6, setShow6] = useState(false);

  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => setShow6(true);

  const [show7, setShow7] = useState(false);

  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);

  const resetCardForm = () => {
    setCardNumber("");
    setCardExpDate("");
    setCardCVV("");
    setFullName("");
    setCardNumbererror(false);
    setCardCVVerror(false);
    setCardExpDateerror(false);
    setCardExpYearerror(false);
    setFullNamerror(false);
    setIsUpdatingCard(false);
    setEditingPaymentId("");
  };

  const handleClose11 = () => {
    setShow4(false);
    resetCardForm();
  };

  const handleOpenUpdateCard = (payment) => {
    setIsUpdatingCard(true);
    setEditingPaymentId(payment.id);
    setCardNumber(`**** **** **** ${payment.card_last_four || ""}`);
    setCardCVV("***");
    setCardExpDate(
      formatExpiryForInput(payment.card_exp || payment.card_exp_datetime || "")
    );
    setFullName(payment.person_name || "");
    setCardNumbererror(false);
    setCardCVVerror(false);
    setCardExpDateerror(false);
    setCardExpYearerror(false);
    setFullNamerror(false);
    setShow4(true);
  };

  const [lastrecordcount, setLastRecordCount] = useState(1);
  const [singalbookingData, setSingalbookingData] = useState([]);
  const [staffs, setstaffs] = useState([]);
  const [selectstaffs, setSelectstaffs] = useState([]);
  const [loading, setLoading] = useState(false);

  const [bookingdate, setBookingDate] = useState(null);
  const [bookingtime, setBookingTime] = useState(null);
  const [notes, setNotes] = useState(null);
  const [staffData, setStaffData] = useState(null);
  const [UpdateTimeDate, setUpdateTimeDate] = useState(0);

  const [cardNumbererror, setCardNumbererror] = useState(false);
  const [cardCVVerror, setCardCVVerror] = useState(false);
  const [cardExpDateerror, setCardExpDateerror] = useState(false);
  const [fullNamerror, setFullNamerror] = useState(false);
  const [cardExpYearerror, setCardExpYearerror] = useState(false);
  const [isUpdatingCard, setIsUpdatingCard] = useState(false);
  const [editingPaymentId, setEditingPaymentId] = useState("");

  const [defaultpaymentmethod, setDefaultpaymentmethod] = useState(null);
  const [timeshow, setTimeshow] = useState(false);
  const [appicall, setAppicall] = useState(false);

  const [loadingapi, setLoadingapi] = useState(false);
  const [user_id, setUser_id] = useState();

  useEffect(() => {
    if (LoggedInData != null) {
      console.log("LoggedInData", LoggedInData);
      getUserData(LoggedInData.id);
      setUser_id(LoggedInData.id);
      getstaff();
    }
  }, [LoggedInData]);

  // useEffect(() => {
  //     if (LoggedInData != null) {
  //         getUserData(LoggedInData.id)
  //     }
  // }, [lastrecordcount]);

  const getPayments = () => {
    setLoadingapi(true);
    const formData = new FormData();
    formData.append("customer_id", LoggedInData.customer_id);

    getpaymentMethod(formData)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.status == "1") {
            const apiResponse = res.data;
            setPaymentMethods(apiResponse.data);
            getdefaultPaymentMethod();
          } else {
            console.log("Something went wrong");
          }
        } else {
          alert("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoadingapi(false);
      });
  };

  const getdefaultPaymentMethod = () => {
    const formData = new FormData();
    formData.append("user_id", LoggedInData.id);

    getdefaultpayment(formData).then((res) => {
      if (res.code === 200) {
        if (res.data.status == "1") {
          const apiResponse = res.data;
          setDefaultpaymentmethod(apiResponse.data.payment_id);
        } else {
          console.log("Something went wrong");
        }
      } else {
        alert("Something went wrong");
      }
    });
  };

  const getcardtype = (date) => {
    const month = date.slice(0, 2);
    const year = date.slice(2);
    const formattedDate = `${month}/${year}`;
    return formattedDate;
  };

  const deleteCard = async (id) => {
    const confirmed = await confirmModal.askConfirmation("Are you sure you want to delete this card?");
    if (!confirmed) return;

    const formData = new FormData();
    formData.append("id", id);
    deletepaymentmethod(formData).then((res) => {
      if (res.code === 200) {
        if (res.data.status == "1") {
          getPayments();
        } else {
          console.log("Something went wrong");
        }
      } else {
        alert("Something went wrong");
      }
    });
  };

  const getstaff = () => {
    getstaffApi(LoggedInData.zip).then((res) => {
      if (res.code === 200) {
        if (res.data.status == "1") {
          const apiResponse = res.data;
          setStaffList(apiResponse.data);
        } else {
          console.log("Something went wrong");
        }
      } else {
        alert("Something went wrong");
      }
    });
  };

  const [validated, setValidated] = useState(false);

  const [cancelbookingloader, setcancelbookingloader] = useState(false);

  const cancelbooking = (event) => {
    setcancelbookingloader(true);
    // event.preventDefault();
    // const form = event.currentTarget;
    // if (form.checkValidity() === false) {
    //     event.preventDefault();
    //     event.stopPropagation();
    //     setcancelbookingloader(false);
    // } else {
    //     if (notes === null || notes?.trim() === "" || notes === undefined) {
    //         NotificationManager.error("Please enter notes");
    //         setcancelbookingloader(false);
    //         return;
    //     }
    //     const formData = new FormData();
    //     formData.append("order_id", orderid);
    //     formData.append("notes", notes);
    //     formData.append("booking_date_time", bookingdatetime);
    //     cancelbookingbyid(formData).then((res) => {
    //         if (res.code === 200) {
    //             if (res.data.status == '1') {
    //                 const apiResponse = res.data;
    //                 console.log(apiResponse);
    //                 setcancelbookingloader(false);
    //                 window.location.reload();
    //             }
    //             else {
    //                 console.log("Something went wrong");
    //                 setcancelbookingloader(false);
    //             }

    //         } else {
    //             setcancelbookingloader(false);
    //             alert("Something went wrong");
    //         }
    //     }).catch((err) => {
    //         console.log("err", err);
    //     }).finally(() => {
    //         setcancelbookingloader(false);
    //         handleClose();
    //     })
    // }
    setValidated(true);
  };

  function getMinutesFromRange(rangeStr) {
    console.log("dddd", rangeStr);
    if (!rangeStr) return;
    const [start, end] = rangeStr.split(" to ").map((t) => t.trim());
    const [eh, em] = end.split(":").map(Number);
    const endMinutes = eh * 60 + em;
    return endMinutes;
  }

  const getbookingdate = (date) => {
    if (date != null) {
      const date1 = date.slice(0, 10);
      return date1;
    }
  };

  const getbookingtime = (date) => {
    if (date != null) {
      const time = date.slice(11);
      return time;
    }
  };

  const digitsOnly = (s = "") => String(s).replace(/\D/g, "");
  const formatExpiryForInput = (value = "") => {
    const raw = String(value || "").trim();
    if (!raw) return "";

    if (raw.includes("/")) {
      const [m = "", y = ""] = raw.split("/");
      const month = m.replace(/\D/g, "").slice(0, 2);
      const yearDigits = y.replace(/\D/g, "");
      const year = yearDigits.length >= 2 ? yearDigits.slice(-2) : yearDigits;
      return month && year ? `${month.padStart(2, "0")}/${year}` : "";
    }

    const dateLike = raw.match(/^(\d{4})-(\d{2})-\d{2}/);
    if (dateLike) {
      return `${dateLike[2]}/${dateLike[1].slice(-2)}`;
    }

    const digits = raw.replace(/\D/g, "");
    if (digits.length >= 6) {
      return `${digits.slice(0, 2)}/${digits.slice(-2)}`;
    }
    if (digits.length >= 4) {
      return `${digits.slice(0, 2)}/${digits.slice(2, 4)}`;
    }
    return "";
  };

  const handleAddCard = () => {
    // if (cardNumber == '' || cardNumber.length != 20 || fullName == '' || cardCVV == '' || cardCVV.length != 3 || cardExpDate == '') {
    //     setAddCardValidate(true)
    // } else {

    if (cardNumber == "" || cardNumber.length != 19) {
      setCardNumbererror(true);
      return;
    } else {
      setCardNumbererror(false);
    }

    const cvv = digitsOnly(cardCVV);
    if (cvv.length < 3 || cvv.length > 4) {
      setCardCVVerror(true);
      return;
    } else {
      setCardCVVerror(false);
    }

    if (cardExpDate == "") {
      setCardExpDateerror(true);
      return;
    }

    if (fullName == "") {
      setFullNamerror(true);
      return;
    } else {
      setFullNamerror(false);
    }

    const expDateParts = cardExpDate?.split("/");

    const expMonth = parseInt(expDateParts[0]);
    const expYear = parseInt(expDateParts[1]);

    const currentMonth = new Date().getMonth() + 1; // Month is 0-indexed, so add 1
    const currentYear = new Date().getFullYear() % 100; // Get the last two digits of the current year

    if (
      expYear < currentYear ||
      (expYear === currentYear && expMonth < currentMonth)
    ) {
      // alert("Card expiration date should be in the future.");
      setCardExpYearerror(true);
      return;
    } else {
      setCardExpYearerror(false);
    }

    const name = fullName?.split(" ");
    if (name.length < 2) {
      setFullNamerror(true);
      return;
    } else {
      setFullNamerror(false);
    }

    const formData = new FormData();
    formData.append("customer_id", LoggedInData.customer_id);
    formData.append("card_number", cardNumber);
    formData.append("person_name", fullName);
    formData.append("card_cvv", cardCVV);
    formData.append("card_exp", cardExpDate);

    createPaymentMethod(formData)
      .then((res) => {
        if (res.code === 200) {
          // alert("credentials added successfully");
          if (res.data.status == "1") {
          getPayments();
          const apiResponse = res.data.data.id;
          // setDefaultpaymentmethod(apiResponse);
          // updatepaymentdetails(apiResponse);
          setCardNumber("");
          setCardExpDate("");
          setCardCVV("");
          }
          else {
            NotificationManager.error(res?.data?.message || "Something went wrong");
          }
        } else {
          NotificationManager.error("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
    setShow4(false);
    resetCardForm();
    // }
  };

  const handleUpdateCard = () => {
    if (cardExpDate == "") {
      setCardExpDateerror(true);
      return;
    } else {
      setCardExpDateerror(false);
    }

    if (fullName == "") {
      setFullNamerror(true);
      return;
    } else {
      setFullNamerror(false);
    }

    const expDateParts = cardExpDate?.split("/");
    const expMonth = parseInt(expDateParts[0]);
    const expYear = parseInt(expDateParts[1]);
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear() % 100;

    if (
      expYear < currentYear ||
      (expYear === currentYear && expMonth < currentMonth)
    ) {
      setCardExpYearerror(true);
      return;
    } else {
      setCardExpYearerror(false);
    }

    const name = fullName?.trim().split(" ");
    if (name.length < 2) {
      setFullNamerror(true);
      return;
    } else {
      setFullNamerror(false);
    }

    const formData = new FormData();
    formData.append("id", editingPaymentId);
    formData.append("person_name", fullName);
    // formData.append("card_number", cardNumber);
    // formData.append("card_cvv", cardCVV);
    formData.append("card_exp", cardExpDate);
    formData.append("customer_id", LoggedInData.id);


    updateStaxPaymentMethod(formData)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.status == 1 || res.data.status === "1") {
            NotificationManager.success("Card updated successfully");
            getPayments();
            setShow4(false);
            resetCardForm();
          } else {
            NotificationManager.error(res?.data?.message || "Something went wrong");
          }
        } else {
          NotificationManager.error("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("err", err);
        NotificationManager.error("Something went wrong");
      });
  };

  useEffect(() => {
    //get value from staffList and compare with staffs and set selectstaffs
    if (staffList.length > 0) {
      let temp = [];
      staffList.map((item) => {
        staffs.map((item2) => {
          if (item.value == item2.staff_ids) {
            temp.push(item);
          }
        });
      });
      setSelectstaffs(temp);
    }

    setBookingDate(getbookingdate(singalbookingData.booking_date_time));
    setBookingTime(getbookingtime(singalbookingData.booking_date_time));
    setNotes(singalbookingData.app_notes);
  }, [staffList, staffs]);

  const savereschedule = () => {
    const bookingdatetime = bookingdate + " " + bookingtime;

    const formData = new FormData();
    formData.append("order_id", singalbookingData.order_id);

    if (UpdateTimeDate === 1) {
      formData.append("order_date", bookingdatetime);
      formData.append("app_notes", notes);
    } else {
      formData.append("app_notes", notes);
    }

    const staffIds = [];
    if (staffData != null) {
      for (let i = 0; i < staffData.length; i++) {
        staffIds.push(staffData[i].value);
      }
      formData.append("staff_ids", staffIds);
    } else {
      const staffIds = [];
      staffs.map((item) => {
        staffIds.push(item.staff_ids);
      });
      formData.append("staff_ids", staffIds);
    }

    saverescheduledata(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            // alert("Booking reschedule successfully");
            handleClose5();
          } else {
            alert("Something went wrong");
          }
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const downloadInvoice = (id) => {
    alert("downloadInvoice");
    // const formData = new FormData();
    // formData.append("order_id", id);
    // downloadInvoiceApi(formData).then((res) => {
    //     if (res.code === 200) {
    //         if (res.data.status == '1') {
    //             const apiResponse = res.data;
    //             window.open(apiResponse.data, '_blank');
    //         }
    //         else {
    //             console.log("Something went wrong");
    //         }

    //     } else {
    //         alert("Something went wrong");
    //     }
    // });
  };

  const getformeteddate = (date) => {
    const newDate = new Date(date);
    var day = newDate.getDate();
    day = day < 10 ? "0" + day : day;
    const month = newDate.toLocaleString("default", { month: "short" });
    const year = newDate.getFullYear();
    var hours = newDate.getHours();
    hours = hours < 10 ? "0" + hours : hours;
    var minutes = newDate.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedDate = `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
    return <div>{formattedDate}</div>;
  };

  const [invoiceList, setInvoiceList] = useState([]);

  const onCardNumberChange = (event) => {
    let { value, name } = event.target;
    let cardNumber = value;
    value = value.replace(/\D/g, "");
    if (/^3[47]\d{0,13}$/.test(value)) {
      cardNumber = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
    } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
      // diner's club, 14 digits
      cardNumber = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
    } else if (/^\d{0,16}$/.test(value)) {
      // regular cc number, 16 digits
      cardNumber = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
        .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
    }

    setCardNumber(cardNumber.trimRight());
  };

  const getinvoice = () => {
    setLoading(true);
    const customer_id = LoggedInData.customer_id;
    getinvoiceApi(customer_id)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            // console.log("response:", response.data.data);
            setInvoiceList(response.data.data);
            getdefaultPaymentMethod();
          } else {
            // alert("No invoice found");
          }
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [showModal8, setShowModal] = useState(false);

  const handleClose8 = () => setShowModal(false);
  const handleShow8 = () => setShowModal(true);
  const [invoiceId, setInvoiceId] = useState("");
  const [invoicetotal, setInvoicetotal] = useState("");
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState("");
  const [selectedCard, setSelectedCard] = useState("");

  const getpaymentCards = (id, total) => {
    // setShowModal(true);
    handleShow8();
    setInvoiceId(id);
    setInvoicetotal(total);
    const formData = new FormData();
    formData.append("customer_id", LoggedInData.customer_id);

    getpaymentMethod(formData)
      .then((res) => {
        if (res.code == 200) {
          const paymentMethod = res.data.data;
          setPaymentMethod(paymentMethod);
          if (paymentMethod && paymentMethod.length != 0 && !selectedCard) {
            setSelectedCard(`cardOption0`);
            setPaymentMethodId(paymentMethod[0].id);
            setDefaultpaymentmethod(paymentMethod[0].id);
          }
          getdefaultPaymentMethod();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const payinvoice = () => {
    const formData = new FormData();
    formData.append("payment_method_id", paymentMethodId);
    formData.append("apply_balance", invoicetotal);
    formData.append("invoiceId", invoiceId);

    payinvoiceApi(formData)
      .then((response) => {
        if (response.code === 200) {
          if (response.data.status === "1") {
            alert("Invoice paid successfully");
            getinvoice();
            handleClose8();
          } else {
            alert("Something went wrong");
          }
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updatepaymentdetails = (payment_id) => {
    const formData = new FormData();
    formData.append("payment_id", payment_id);
    formData.append("user_id", LoggedInData.id);

    updatepaymentMethod(formData).then((res) => {
      if (res.code === 200) {
        if (res.data.status == 1) {
          const apiResponse = res.data;
          getPayments();
        } else {
          console.log("Something went wrong");
        }
      } else {
        alert("Something went wrong");
      }
    });
  };

  const checkTimeAndAlert = (timeString) => {
    setAppicall(true);
    const formData = new FormData();
    formData.append("booking_date_time", timeString);

    checkTimeis24hours(formData)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.status == 1) {
            const apiResponse = res.data.data;
            if (apiResponse < 24) {
              setTimeshow(true);
            } else {
              setTimeshow(false);
            }
          } else {
            console.log("data not found");
          }
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setAppicall(false);
        handleShow();
      });
  };

  const sendEmailToSupport = (order_id) => {
    const formData = new FormData();
    formData.append("order_id", order_id);

    sendEmailToSupportApi(formData)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.status == 1) {
            const apiResponse = res.data;
            alert("Email sent successfully");
          } else {
            console.log("Something went wrong");
          }
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [defaulttimezone, setDefaulttimezone] = useState("");

  useEffect(() => {
    getservertimzone();
  }, []);
  const getservertimzone = () => {
    getservertimzoneapi().then((res) => {
      if (res.code === 200) {
        if (res.data.status == 1) {
          const apiResponse = res.data;
          setDefaulttimezone(apiResponse.data.date);
        } else {
          console.log("Something went wrong");
        }
      } else {
        alert("Something went wrong");
      }
    });
  };

  const isWithin24Hours = async (bookingDateTime) => {
    const bookingDate = new Date(bookingDateTime);
    const currentDate = new Date(defaulttimezone);
    const timeDifference = bookingDate.getTime() - currentDate.getTime();
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return hoursDifference <= 24 && hoursDifference >= 0;
  };

  const [show9, setShow9] = useState(false);

  const handleClose9 = () => setShow9(false);
  const handleShow9 = () => setShow9(true);

  const [review_title, setReview_title] = useState("");
  const [review_text, setReview_text] = useState("");
  const [staff_id, setStaff_id] = useState("");

  const [reviewstar, setReviewstar] = useState("");

  const reviewBooking = () => {
    if (review_title === "") {
      NotificationManager.error("Please enter review title");
      return;
    }

    if (reviewstar === "") {
      NotificationManager.error("Please enter star");
      return;
    }

    if (review_text === "") {
      NotificationManager.error("Please enter review text");
      return;
    }

    const formData = new FormData();
    formData.append("review_title", review_title);
    formData.append("rating", reviewstar);
    formData.append("review_text", review_text);
    formData.append("client_id", LoggedInData.id);
    formData.append(
      "reviewer_name",
      LoggedInData.first_name + " " + LoggedInData.last_name
    );
    formData.append("order_id", orderid);
    formData.append("staff_id", staff_id);

    postreview(formData)
      .then((res) => {
        if (res.code === 200) {
          const ApiResponse = res.data;
          handleClose9();
          getUserData(LoggedInData.id);
          NotificationManager.success("Review successfully Submitted");
          // setReviewdata(ApiResponse.data);
          // window.location.href = "/getreviews";
          window.location.reload();
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [show10, setShow10] = useState(false);
  const handleClose10 = () => setShow10(false);
  const handleShow10 = () => setShow10(true);

  const [show12, setShow12] = useState(false);
  const handleClose12 = () => {
    setShow12(false);
    setSelectedDate(null);
    setExpectedduration(null);
    setValidationError(""); // Clear validation error when modal closes
    setRescheduleBookingTime("");
    setRescheduleClientNotes("");
    setHasCats(false);
    setHasDogs(false);
    staffSelectedFromBooking.current = null; // Clear the ref when modal closes
  };
  const handleShow12 = () => setShow12(true);

  const [selectedShift, setSelectedShift] = useState("morning");
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [validationError, setValidationError] = useState("");

  const [selectedSatff, setSelectedSatff] = useState(0);
  const [expectedduration, setExpectedduration] = useState(0);
  
  // Track if staff was selected from booking data (to preserve it during slot recalculation)
  const staffSelectedFromBooking = useRef(null);

  // Generate time slots based on selected shift
  const getTimeSlots = (shift) => {
    if (shift === "morning") {
      // Morning: 8:00 AM to 11:00 AM (hourly slots)
      return [
        { value: "08:00", label: "8:00 AM" },
        { value: "09:00", label: "9:00 AM" },
        { value: "10:00", label: "10:00 AM" },
        { value: "11:00", label: "11:00 AM" },
      ];
    } else {
      // Afternoon: 12:00 PM to 5:00 PM (hourly slots)
      return [
        { value: "12:00", label: "12:00 PM" },
        { value: "13:00", label: "1:00 PM" },
        { value: "14:00", label: "2:00 PM" },
        { value: "15:00", label: "3:00 PM" },
        { value: "16:00", label: "4:00 PM" },
        { value: "17:00", label: "5:00 PM" },
      ];
    }
  };

  const timeSlots = getTimeSlots(selectedShift);

  const reschedulebooking = (booking) => {
    console.log("=== Reschedule Booking Data ===", booking);
    console.log("booking.request:", booking.request);
    console.log("booking.app_notes:", booking.app_notes);
    setSingalbookingData([booking]);
    setSelectedDate(moment(booking.booking_date_time).format("YYYY-MM-DD"));
    setExpectedduration(getMinutesFromRange(booking.estimated_duration));
    
    // Pre-fill special client request if it exists, but remove "Requested Technician" from display
    const cleanedRequest = removeRequestedTechnicianFromRequest(booking.request || "");
    
    // Parse booking time and instructions from the request
    const parsed = parseSpecialClientRequests(cleanedRequest);
    setRescheduleBookingTime(parsed.bookingTime);
    setRescheduleClientNotes(parsed.instructions);
    setHasCats(parsed.hasCats);
    setHasDogs(parsed.hasDogs);
    
    // Find and select the staff member
    let staffToSelect = null;
    
    // First, check if there's a "Requested Technician" in the request
    const requestedTech = getRequestedTechnician(booking.request || "");
    if (requestedTech && staffList && staffList.length > 0) {
      // Find technician by name (case-insensitive partial match)
      staffToSelect = staffList.find(
        staff => staff.label && staff.label.toLowerCase().includes(requestedTech.toLowerCase())
      );
    }
    
    // If no requested technician found, try to match by staff_name (more reliable)
    if (!staffToSelect && booking.staff_name && staffList && staffList.length > 0) {
      // Handle staff_name - might be comma-separated, clean it up
      const staffNames = booking.staff_name.split(',').map(name => name.trim()).filter(name => name);
      
      // Try to find matching staff by name (case-insensitive)
      for (const staffName of staffNames) {
        staffToSelect = staffList.find(
          staff => staff.label && staff.label.toLowerCase() === staffName.toLowerCase()
        );
        if (staffToSelect) break;
      }
    }
    
    // If still no match, try to match by staff_ids
    if (!staffToSelect && booking.staff_ids && staffList && staffList.length > 0) {
      // Skip if staff_ids is "115" (Unassigned) or "0" or empty
      const staffIdStr = String(booking.staff_ids).trim();
      if (staffIdStr && staffIdStr !== "0" && staffIdStr !== "115" && staffIdStr !== "") {
        // Handle staff_ids - might be string, number, or comma-separated
        let staffIdToMatch = booking.staff_ids;
        
        // If it's a string with commas, take the first one
        if (typeof staffIdToMatch === 'string' && staffIdToMatch.includes(',')) {
          staffIdToMatch = staffIdToMatch.split(',')[0].trim();
        }
        
        // Convert to number for comparison
        const staffIdNum = typeof staffIdToMatch === 'string' ? parseInt(staffIdToMatch, 10) : staffIdToMatch;
        
        // Only proceed if we got a valid number
        if (!isNaN(staffIdNum) && staffIdNum > 0) {
          // Find matching staff by value (try both string and number comparison)
          staffToSelect = staffList.find(
            staff => {
              const staffValue = staff.value;
              return staffValue == staffIdNum || 
                     staffValue === staffIdNum || 
                     String(staffValue) === String(staffIdNum) ||
                     Number(staffValue) === Number(staffIdNum);
            }
          );
        }
      }
    }
    
    // Set the selected staff if found
    if (staffToSelect && staffToSelect.value) {
      setSelectedSatff(staffToSelect.value);
      // Track that this staff was selected from booking data
      staffSelectedFromBooking.current = staffToSelect.value;
    } else {
      setSelectedSatff(0);
      staffSelectedFromBooking.current = null;
    }
    
    // Auto-select shift based on booking time
    const bookingTimeFromDate = moment(booking.booking_date_time).format("HH:mm:ss");
    if (bookingTimeFromDate === "08:00:00" || bookingTimeFromDate.startsWith("08:")) {
      setSelectedShift("morning");
    } else if (bookingTimeFromDate === "12:00:00" || bookingTimeFromDate.startsWith("12:")) {
      setSelectedShift("afternoon");
    } else {
      // Default to morning if time doesn't match
      setSelectedShift("morning");
    }
    
    handleShow12();
  };

  // Use ref to track if we're updating from useEffect to prevent infinite loops
  const isUpdatingFromEffect = useRef(false);
  
  // Combine rescheduleBookingTime and rescheduleClientNotes into specialClientRequests (similar to Step02.js)
    useEffect(() => {
      isUpdatingFromEffect.current = true;
      
      let combined = `Booking Time : ${rescheduleBookingTime || ""}\nInstructions : ${rescheduleClientNotes || ""}`;
      
      // Add pets information (similar to Step02.js)
      if (hasCats && hasDogs) {
        combined = `${combined}\nPets at Home: Dog and Cat`;
      } else if (hasCats) {
        combined = `${combined}\nPets at Home: Cat`;
      } else if (hasDogs) {
        combined = `${combined}\nPets at Home: Dog`;
      }
      
      // Check if selected technician is Breann and hasCats is true (similar to Step02.js)
      let selectedTech = null;
      if (selectedSatff && selectedSatff !== 0 && staffList && staffList.length > 0) {
        selectedTech = staffList.find(
          tech => tech.value == selectedSatff || tech.value === selectedSatff
        );
      }
      
      if (selectedTech?.label) {
        const isBreann = selectedTech.label.includes("Breann");
        
        // If Breann is selected and hasCats is true, always add as requested technician (regardless of slots)
        if (hasCats && isBreann) {
          combined += `\nRequested Technician : ${selectedTech.label}`;
        } else if (isBreann && !hasCats) {
          // Breann selected but cat NOT selected - don't add as requested technician
          // Don't preserve requested technician here - onClick handler will manage it based on slots
          // If Breann has slots, onClick removes it; if no slots, onClick adds it
          // We don't preserve here to avoid keeping it when Breann has slots
        } else {
          // For other technicians (not Breann), preserve any existing "Requested Technician" 
          // that was set by onClick handler (when they have no slots)
          const currentRequest = specialClientRequests || "";
          const requestedTechMatch = currentRequest.match(/Requested Technician\s*:\s*(.+?)(?:\r\n|\n|$)/i);
          
          // Only preserve if it's not Breann (because Breann without cat should be managed by onClick)
          if (requestedTechMatch) {
            const requestedTechName = requestedTechMatch[1].trim();
            const isRequestedTechBreann = requestedTechName.includes("Breann");
            
            // Don't preserve if it's Breann (because Breann without cat should be managed by onClick)
            if (!isRequestedTechBreann) {
              combined += `\nRequested Technician : ${requestedTechName}`;
            }
          }
        }
      } else {
        // No technician selected, preserve any existing "Requested Technician" information
        const currentRequest = specialClientRequests || "";
        const requestedTechMatch = currentRequest.match(/Requested Technician\s*:\s*.+?(?:\r\n|\n|$)/i);
        
        if (requestedTechMatch) {
          combined += `\n${requestedTechMatch[0].trim()}`;
        }
      }
      
      setSpecialClientRequests(combined);
      
      // Reset flag after a short delay to allow other updates
      setTimeout(() => {
        isUpdatingFromEffect.current = false;
      }, 0);
  }, [rescheduleBookingTime, rescheduleClientNotes, hasCats, hasDogs, selectedSatff, staffList]);

  const [availableMorningTime, setavailableMorningTime] = useState([]);
  const [availableAfternoonTime, setavailableAfternoonTime] = useState([]);


  useEffect(() => {
    if (selectedDate != null) {
      staffList.forEach((element) => {
        getstaffTime(selectedDate, element.value).then((res) => {
          if (res.code === 200) {
            const apiResponse = res.data;
            if (apiResponse.data.length > 0) {
              getAvailableHourlySlots(
                selectedDate,
                apiResponse.data,
                "06:00",
                "20:00",
                expectedduration,
                element.value,
                element.label
              );
            } else {
              // getavailableTimeSlots([], selectedDate);
            }
          } else {
            alert("Something went wrong");
          }
        });
      });
    }
  }, [selectedDate]);

  function getAvailableHourlySlots(
    date,
    bookings,
    workStart = "06:00",
    workEnd = "20:00",
    requiredMinutes = 180,
    staff_id,
    label
  ) {
    // console.log("element.value staff_id", staff_id);
    const requiredHours = requiredMinutes / 60;

    const workStartDate = new Date(`${date} ${workStart}:00`);
    const workEndDate = new Date(`${date} ${workEnd}:00`);

    // Convert bookings to datetime objects
    const blocked = bookings.map((b) => ({
      start: new Date(b.start),
      end: new Date(b.end),
    }));

    // Step 1: Generate all possible 1-hour free slots
    let freeHourly = [];

    for (
      let hour = workStartDate.getHours();
      hour < workEndDate.getHours();
      hour++
    ) {
      let s = new Date(`${date} ${String(hour).padStart(2, "0")}:00:00`);
      let e = new Date(s.getTime() + 60 * 60000);

      if (e > workEndDate) continue;

      // Overlap Check (touch bhi invalid)
      const isBlocked = blocked.some(
        (b) => (s < b.end && e > b.start) || e.getTime() === b.start.getTime()
      );

      if (!isBlocked) {
        freeHourly.push(s);
      }
    }

    // Step 2: From these, keep only slots that can form a continuous requiredHours block
    let finalSlotsMorning = [];
    let finalSlotsAfternoon = [];

    for (let i = 0; i < freeHourly.length; i++) {
      let ok = true;

      for (let j = 0; j < requiredHours; j++) {
        if (!freeHourly[i + j]) {
          ok = false;
          break;
        }

        let diffHours = (freeHourly[i + j] - freeHourly[i]) / (1000 * 60 * 60);

        if (diffHours !== j) {
          ok = false;
          break;
        }
      }

      if (ok) {
        const startHour = freeHourly[i].getHours();
        const endHour = startHour + 1;

        // if startHour is between 6 and 12, add to finalSlotsMorning
        if (startHour >= 6 && startHour < 12) {
          finalSlotsMorning.push(
            // `${label} - ${String(startHour).padStart(2, "0")}-${String(
            //   endHour
            // ).padStart(2, "0")}`
            `${label} - ${String(startHour).padStart(2, "0")} `
          );
        }
        // if startHour is between 12 and 20, add to finalSlotsAfternoon
        else if (startHour >= 12 && startHour < 20) {
          finalSlotsAfternoon.push(
            `${label} - ${String(startHour).padStart(2, "0")}`
            // `${label} - ${String(startHour).padStart(2, "0")}-${String(
            //   endHour
            // ).padStart(2, "0")}`
          );
        }
      }
    }

    // Save MORNING slots staff-wise
    setavailableMorningTime((prev) => {
      const newMorning = {
        ...prev,
        [staff_id]: finalSlotsMorning,
      };

      // Check if NO slots available across all staff
      const totalSlots = Object.values(newMorning).flat().length;
      if (totalSlots === 0) {
        // Only clear selected staff if it wasn't set from booking data
        // This preserves the staff selection when rescheduling
        if (!staffSelectedFromBooking.current) {
          setSelectedSatff(0);
          setSelectedTimeSlot(null);
        }
      }

      return newMorning;
    });

    // Save AFTERNOON slots staff-wise
    setavailableAfternoonTime((prev) => {
      const newAfternoon = {
        ...prev,
        [staff_id]: finalSlotsAfternoon,
      };

      // Check if NO slots available across all staff
      const totalSlots = Object.values(newAfternoon).flat().length;
      if (totalSlots === 0) {
        // Only clear selected staff if it wasn't set from booking data
        // This preserves the staff selection when rescheduling
        if (!staffSelectedFromBooking.current) {
          setSelectedSatff(0);
          setSelectedTimeSlot(null);
        }
      }

      return newAfternoon;
    });
  }

  const [loadingsppiner, setLoadingSpinner] = useState(false);

  const [sdate, setSdate] = useState(new Date());

  const sevenDaysLater = new Date();
  sevenDaysLater.setDate(sevenDaysLater.getDate() + 7);

  const [edate, setEdate] = useState("2050-12-31");
  const [datetype, setDatetype] = useState("today");

  const [dates, setDates] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const handleButtonClick = () => {
    // handleClose10();
    // setLoadingSpinner(true);
    // setTimeout(() => {
    //     setLoadingSpinner(false);
    // }, 6000);
    getUserData(user_id);
  };

  const [isLoadingschedule, setIsLoadingschedule] = useState(false);

  const handleSubmit = () => { ///////called
    // Clear previous validation errors
    setValidationError("");

    // Validation: Booking time and instructions are always required
    if (!rescheduleBookingTime || rescheduleBookingTime.trim() === "") {
      setValidationError("Please select a booking time to proceed");
      return;
    }
    
    if (!rescheduleClientNotes || rescheduleClientNotes.trim() === "") {
      setValidationError("Please fill special instructions to proceed");
      return;
    }

    // Validation: Check if a time slot is selected when slots are available
    // OR if special client request is filled when no slots are available
    if (selectedShift) {
      const slotsAvailable =
        selectedShift === "morning"
          ? Object.values(availableMorningTime).flat().length > 0
          : Object.values(availableAfternoonTime).flat().length > 0;

      // If slots are available but none is selected, show error
      // if (slotsAvailable && !selectedTimeSlot) {
      //   setValidationError("Please select a time slot to proceed");
      //   return;
      // }

      // // If NO slots are available and special client request is empty, show error
      // if (
      //   !slotsAvailable &&
      //   (!specialClientRequests || specialClientRequests.trim() === "")
      // ) {
      //   setValidationError("Please fill special client request to proceed");
      //   return;
      // }
    }

    setIsLoadingschedule(true);
    const formData = new FormData();
    if (selectedDate) {
      let finalDateTime = selectedDate; // default: only date

      if (selectedTimeSlot && selectedShift) {
        // Extract hour from slot string format: "Technician Name - HH"
        // Example: "John Doe - 06" -> extract "06"
        // const slotParts = selectedTimeSlot.split(" - ");
        // const hourString = slotParts[slotParts.length - 1].trim(); // Get last part and trim
        // let hour = parseInt(hourString); // e.g., "06" → 6, "14" → 14

        // No need to convert if the hour is already in 24-hour format from the slot
        // The slots already contain the correct 24-hour format (06 for morning, 14 for afternoon)

        // create final datetime in format: YYYY-MM-DD HH:mm:ss
        // const final = `${selectedDate} ${hourString.padStart(2, "0")}:00:00`;

        // finalDateTime = final;
        // formData.append("order_date", finalDateTime);
        const defaultTime = selectedShift === "morning" ? "08:00:00" : "12:00:00";
        formData.append("order_date", `${selectedDate} ${defaultTime}`);
      } else {
        // Check if no slots available and special request is filled
        const hasNoSlots = !selectedTimeSlot;
        const hasSpecialRequest =
          specialClientRequests && specialClientRequests.trim() !== "";

        if (hasNoSlots && hasSpecialRequest) {
          // Special client request scenario - use shift default time
          const defaultTime = selectedShift === "morning" ? "08:00:00" : "12:00:00";
          formData.append("order_date", `${selectedDate} ${defaultTime}`);
        } else {
          // Normal scenario without time slot - use shift default time
          const defaultTime = selectedShift === "morning" ? "08:00:00" : "12:00:00";
          formData.append("order_date", `${selectedDate} ${defaultTime}`);
        }
      }
    }

    formData.append("isSloteAvaible", selectedTimeSlot ? 1 : 0);
    formData.append("selectedShift", selectedShift);
    formData.append("email", LoggedInData.user_email);
    formData.append("phone", LoggedInData.phone);
    formData.append("first_name", LoggedInData.first_name);
    formData.append("last_name", LoggedInData.last_name);

    if (singalbookingData[0]?.order_id) {
      formData.append("order_id", singalbookingData[0].order_id);
    }

    // Check if special request scenario (no slots + special request filled)
    const hasNoSlots = !selectedTimeSlot;
    const hasSpecialRequest =
      specialClientRequests && specialClientRequests.trim() !== "";
    const hasTechnicianSelected = selectedSatff && selectedSatff !== 0;

    if (hasNoSlots && hasSpecialRequest && !hasTechnicianSelected) {
      // General special client request without specific technician: send to staff_ids 79
      formData.append("staff_ids", "79");
    } else if (hasTechnicianSelected) {
      // Technician selected (with or without slots): send their ID
      formData.append("staff_ids", selectedSatff);
    } else {
      // Normal flow: no technician selected
      formData.append("staff_ids", 0);
    }

    // Always send request (special client requests)
    formData.append("request", specialClientRequests || "");

    rescheduleBooked(formData)
      .then((res) => {
        if (res.code === 200) {
          const apiResponse = res.data;

          if (apiResponse.status == "1") {
            setIsLoadingschedule(false);
            setBookings(apiResponse.data);
            getUserData(LoggedInData.id);
            NotificationManager.success(apiResponse.message);
          } else {
            setIsLoadingschedule(false);
            NotificationManager.error(apiResponse.message);
            setBookings([]);
          }
        } else {
          setIsLoadingschedule(false);
          NotificationManager.error(res.data.message);
        }

        handleClose12();
        // window.location.reload();
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoadingschedule(false);
        NotificationManager.error(err.message);
        handleClose12();
        // window.location.reload();
      })
      .finally(() => {
        setIsLoadingschedule(false);
      });
  };
  const getUserData = (uid) => {
    setLoading(true);
    setLoadingSpinner(true);
    handleClose10();
    const formData = new FormData();
    formData.append("user_id", uid);
    formData.append("start_date", moment(sdate).format("YYYY-MM-DD"));
    formData.append("end_date", moment(edate).format("YYYY-MM-DD"));
    formData.append("datetype", datetype);
    getUserBookingfront(formData)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.status == "1") {
            const apiResponse = res.data;
            setBookings(apiResponse.data);
          } else {
            console.log("Something went wrong");
            setBookings([]);
          }
        } else {
          alert("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoading(false);
        setLoadingSpinner(false);
      });
  };

  // is there time zone also with the technicians

  const filterEarliestSlots = (slots) => {
    const technicianMap = {};
    slots.forEach((slot) => {
      const parts = slot.split(" - ");
      if (parts.length >= 2) {
        const techName = parts[0].trim();
        const timeStr = parts[1].trim();
        const timeValue = parseInt(timeStr);

        if (
          !technicianMap[techName] ||
          timeValue < technicianMap[techName].time
        ) {
          technicianMap[techName] = {
            time: timeValue,
            slot: slot,
          };
        }
      }
    });
    return Object.values(technicianMap).map((item) => item.slot);
  };

  var availableSlots;
  // if singalbookingData length > 0 then merege both availableMorningTime & availableAfternoonTime in availableSlots
  if (singalbookingData.length > 0) {
    if (
      singalbookingData[0].service_id == "6" ||
      singalbookingData[0].service_id == "8"
    ) {
      const allSlots = [
        ...Object.values(availableAfternoonTime).flat(),
        ...Object.values(availableMorningTime).flat(),
      ];
      availableSlots = filterEarliestSlots(allSlots);
    } else {
      const rawSlots =
        selectedShift === "morning"
          ? Object.values(availableMorningTime).flat()
          : Object.values(availableAfternoonTime).flat();
      availableSlots = filterEarliestSlots(rawSlots);
    }
  } else {
    const rawSlots =
      selectedShift === "morning"
        ? Object.values(availableMorningTime).flat()
        : Object.values(availableAfternoonTime).flat();
    availableSlots = filterEarliestSlots(rawSlots);
  }

  return (
    <>
      <CommonConfirmModal
        show={confirmModal.show}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={confirmModal.onConfirm}
        onClose={confirmModal.onClose}
      />
      <Modal show={show} onHide={handleClose} centered>
        <Form noValidate validated={validated} onSubmit={cancelbooking}>
          <Modal.Body className="custum-modal-body">
            {/* To cancel the booking please contact our Support team at <a href="tel:888-438-1781">888-438-1781</a> */}
            <b>Your request is being processed.</b>
            <br></br>
            <p>
              For the security of your account Please keep your lines open and
              our support team will contact you.
            </p>
            {/* <div className="body-text">
                            <h3 className='mb-3'>Really want to cancel this booking?</h3>
                            <Form.Group className="mb-4" controlId="validationCustom01">
                                <Form.Control as="textarea" rows={3} required type="text" value={notes || ""} onChange={
                                    (e) => {
                                        setNotes(e.target.value)
                                    }
                                } placeholder=" " />
                                <Form.Control.Feedback type="invalid">
                                    Please enter notes
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-4" controlId="validationCustom01">
                                {
                                    timeshow && timeshow ? <span className='note-text'>Note : Your appointment is scheduled less than 24 hours away. If you cancel now we will have to charge a $65 cancellation fee</span> : null
                                }
                            </Form.Group>

                        </div>
                        <div className='row'>
                            <div className='modal-btn'>
                                {
                                    <>
                                        {
                                            cancelbookingloader ? <button href="#" className='btn Active-bttn' style={{ minWidth: "100%" }} disabled> <Spinner animation="border" /> </button> :
                                                (
                                                    <>
                                                        <button href="#" className='btn Active-bttn' type="submit">Yes</button>
                                                        <button href="#" className='btn Cancel-bttn' onClick={handleClose}>No</button>
                                                    </>
                                                )
                                        }

                                    </>

                                }

                            </div>
                        </div> */}
          </Modal.Body>
        </Form>
      </Modal>

      {/* Edit Card modal start here */}
      <Modal show={show3} onHide={handleClose3} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Card Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Card Number</Form.Label>
                <Form.Control
                  required
                  type="name"
                  placeholder="**** **** **** 9856"
                  className="custom-input"
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Exp. Date</Form.Label>
                <Form.Control
                  required
                  type="Text"
                  placeholder="MM/YY"
                  className="custom-input"
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">CVV</Form.Label>
                <Form.Control
                  required
                  type="number"
                  placeholder="  "
                  className="custom-input"
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Full Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Full Name"
                  className="custom-input"
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="modal-btn">
              <button
                href="#"
                className="btn Active-bttn"
                onClick={handleClose3}
              >
                Save Changes
              </button>
              <button
                href="#"
                className="btn Cancel-bttn"
                onClick={handleClose3}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* modal End here */}

      {/* Add Card modal start here */}
      <Modal show={show4} onHide={handleClose11} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isUpdatingCard ? "Update Card Details" : "New Card Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Card Number</Form.Label>
                <Form.Control
                  required
                  type="tel"
                  className="custom-input"
                  value={cardNumber}
                  onChange={onCardNumberChange}
                  disabled={isUpdatingCard}
                  onBlur={() => {
                    if (isUpdatingCard) {
                      setCardNumbererror(false);
                    } else if (cardNumber.length < 19) {
                      setCardNumbererror(true);
                    } else {
                      setCardNumbererror(false);
                    }
                  }}
                  maxLength="19"
                />
                {!isUpdatingCard && cardNumbererror == true ? (
                  <p style={{ color: "red" }}>card number is required</p>
                ) : null}
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Exp. Date</Form.Label>
                <Form.Control
                  required
                  type="Text"
                  placeholder="MM/YY"
                  className="custom-input"
                  value={cardExpDate}
                  {...getExpiryDateProps({
                    onChange: (e) => setCardExpDate(e.target.value),
                  })}
                />
                {cardExpDateerror == true ? (
                  <p style={{ color: "red" }}>please enter card exipry date</p>
                ) : (
                  ""
                )}
                {cardExpYearerror == true ? (
                  <p style={{ color: "red" }}>
                    Card expiration date should be in the future.
                  </p>
                ) : (
                  ""
                )}
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">CVV</Form.Label>
                {/* <Form.Control required type="number" placeholder="CVV" className='custom-input'
                                    value={cardCVV}
                                    onInput={
                                        (e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4)
                                        }
                                    }
                                    onChange={(e) => setCardCVV(e.target.value)} /> */}
                <Form.Control
                  required
                  type={isUpdatingCard ? "text" : "number"}
                  placeholder="CVV"
                  className="custom-input"
                  value={cardCVV}
                  disabled={isUpdatingCard}
                  onInput={(e) => {
                    let value = e.target.value;
                    value = value.replace(/\D/g, "");
                    value = value.slice(0, 4);
                    e.target.value = value;
                    setCardCVVerror(false);
                  }}
                  onChange={(e) => setCardCVV(e.target.value)}
                />
                {!isUpdatingCard && cardCVVerror == true ? (
                  <p style={{ color: "red" }}>please enter cvv</p>
                ) : (
                  ""
                )}
                {/* {cardCVV.length != 3 ? <p style={{ color: 'red' }}>cvv must have 3 digits</p> : ''} */}
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Full Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Full Name"
                  className="custom-input"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
                {fullNamerror == true ? (
                  <p style={{ color: "red" }}>please enter full name</p>
                ) : (
                  ""
                )}
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="modal-btn">
              <button
                href="#"
                className="btn Active-bttn"
                type="submit"
                onClick={isUpdatingCard ? handleUpdateCard : handleAddCard}
              >
                {isUpdatingCard ? "Update" : "Save"}
              </button>
              <button
                href="#"
                className="btn Cancel-bttn"
                onClick={handleClose11}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* modal End here */}

      {/* Reschedule Booking modal start here */}
      <Modal show={show5} onHide={handleClose5} centered>
        <Modal.Header closeButton>
          <div>
            <Modal.Title>Reschedule Booking </Modal.Title>
            <div className="">
              <div className="d-flex align-items-center">
                <div className="custom-lable">Current Booking Date:</div>
                <div className="custom-txt">
                  <div>
                    <h6>
                      {getbookingdate(singalbookingData.booking_date_time)}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="custom-lable">Current Booking Time :</div>
                <div className="custom-txt">
                  <div>
                    <h6>
                      {getbookingtime(singalbookingData.booking_date_time)}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="custom-lable">Ammount :</div>
                <div className="custom-txt">
                  <div>
                    <h6>{`$${singalbookingData.amount}`}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          <div className="row">
            <div className="col-md-12">
              <Form.Group
                className="booking-custom-lable mb-4"
                controlId="formBasicEmail"
              >
                <Form.Label className="">Select Staff</Form.Label>
                <Select
                  isMulti
                  defaultValue={selectstaffs}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  options={staffList}
                  onChange={(e) => setStaffData(e)}
                />
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Note</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  required
                  type="text"
                  value={notes || ""}
                  onChange={(e) => {
                    setNotes(e.target.value);
                  }}
                  placeholder=" "
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <div className="d-flex align-items-center">
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    onClick={() => {
                      setShowText(!showText);

                      setUpdateTimeDate(1);
                    }}
                  />
                  <Form.Label className="custom-lable ms-2 mb-0">
                    Update Schedule Date & Time
                  </Form.Label>
                </div>
              </Form.Group>
            </div>
          </div>

          {showText && (
            <>
              <div className="row">
                <div className="col-md-12">
                  <Form.Group className="mb-4" controlId="validationCustom01">
                    <Form.Label className="custom-lable">
                      {" "}
                      Update Date & Time
                    </Form.Label>
                    <div className="row">
                      <div className="col-md-6">
                        <Form.Control
                          type="Date"
                          placeholder=" "
                          value={bookingdate}
                          onChange={(e) => setBookingDate(e.target.value)}
                          className="custom-input"
                        />
                      </div>
                      <div className="col-md-6">
                        <Form.Control
                          type="time"
                          placeholder="10:30 AM"
                          value={bookingtime}
                          onChange={(e) => setBookingTime(e.target.value)}
                          className="custom-input"
                        />
                      </div>
                    </div>
                  </Form.Group>
                </div>
              </div>
            </>
          )}

          <div className="row">
            <div className="modal-btn">
              <button
                href="#"
                className="btn Active-bttn"
                onClick={savereschedule}
              >
                Update Appointment
              </button>
              <button
                href="#"
                className="btn Cancel-bttn"
                onClick={handleClose5}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* modal End here */}

      {/* Cancel booking modal start here */}
      <Modal show={show6} onHide={handleClose6} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          <div className="row">
            <div className="col-md-12">
              <div className="custom-lable text-center mb-4">
                Are you sure you want to cancel this booking?
              </div>
            </div>
          </div>

          <div className="row">
            <div className="modal-btn">
              <button
                href="#"
                className="btn Active-bttn"
                onClick={handleClose6}
              >
                Yes
              </button>
              <button
                href="#"
                className="btn Cancel-bttn"
                onClick={handleClose6}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* modal End here */}

      {/* Delete Card modal start here */}
      <Modal show={show7} onHide={handleClose7} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          <div className="row">
            <div className="col-md-12">
              <div className="custom-lable text-center mb-4">
                Are you sure you want to Delete this Card?
              </div>
            </div>
          </div>

          <div className="row">
            <div className="modal-btn">
              <button
                href="#"
                className="btn Active-bttn"
                onClick={handleClose7}
              >
                Delete
              </button>
              <button
                href="#"
                className="btn Cancel-bttn"
                onClick={handleClose7}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* modal End here */}

      {/* Payment Method modal End here */}
      <Modal
        show={showModal8}
        className="Sidebar-Modal-end"
        onHide={handleClose8}
      >
        <Modal.Header closeButton>
          <Modal.Title>Fattmerchant Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          {paymentMethod.map((item, index) => {
            // const cardOptionId = `cardOption${index}`;
            // const isDefaultCard = defaultpaymentmethod && item.id === defaultpaymentmethod;
            // const isFirstCard = index === 0;
            // const isChecked = selectedCard === cardOptionId || (!selectedCard && (isDefaultCard || (!defaultpaymentmethod && isFirstCard)));
            const isChecked = defaultpaymentmethod
              ? item.id === defaultpaymentmethod
              : index === 0;
            const isCardExpired =
              checkCardExpiration(item.card_exp) === "Your Card is Expired";
            return (
              <div class="form-check mb-3">
                <div className="d-flex align-items-center">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    name="cardOption"
                    id={`cardOption${index}`}
                    value={`cardOption${index}`}
                    // checked={defaultpaymentmethod ? item.id === defaultpaymentmethod : index === 0}
                    defaultChecked={
                      defaultpaymentmethod
                        ? item.id === defaultpaymentmethod
                        : index === 0
                    }
                    onChange={(e) => {
                      setPaymentMethodId(item.id);
                      setDefaultpaymentmethod(item.id);
                    }}
                    disabled={isCardExpired}
                  />
                  <label
                    class="form-check-label payment-card-details"
                    for="flexRadioDefault1"
                  >
                    <div className="card payment-card-details">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          <div>
                            <div className="card-title h5">
                              ****-****-****-{item.card_last_four || " "}
                            </div>
                            <p className="card-text">{item.nickname || " "}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            );
          })}
          <div className="row">
            <div className="modal-btn justify-content-end">
              <button
                href="#"
                className="btn g-btn me-3"
                type="submit"
                onClick={payinvoice}
              >
                Pay Now
              </button>
              <button
                href="#"
                className="btn btn-danger"
                onClick={handleClose8}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Payment Method modal End here */}

      <Modal show={show9} onHide={handleClose9} centered>
        <Modal.Header closeButton>
          <Modal.Title>Give Feedback!</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custum-modal-body">
          <div className="row">
            <div className="col-md-12">
              <Form.Label className="custom-lable">
                Order ID :- {orderid}
              </Form.Label>
            </div>
            <div className="col-md-12">
              <Form.Label className="custom-lable">
                Booking Amount :- {`$${bookingAmount}`}
              </Form.Label>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Label className="custom-lable">
                Technician's Name :-{" "}
                {bookingStaffName
                  .replace(/\s*,\s*/g, ",")
                  .replace(/^,|,$/g, "")}
              </Form.Label>
            </div>
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">
                  Booking Date Time :- {bookingdatetime}
                </Form.Label>
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Review Title</Form.Label>
                <Form.Control
                  required
                  type="text"
                  onChange={(e) => setReview_title(e.target.value)}
                  placeholder="Enter Review Title"
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Rating</Form.Label>
                <div className="form-rating">
                  {Array.from({ length: 5 }, (_, i) => (
                    <span key={i} onClick={(e) => setReviewstar(i + 1)}>
                      {i < reviewstar ? <BsStarFill /> : <BsStar />}
                    </span>
                  ))}
                </div>
                {/* <Form.Control required type="number" placeholder="Enter Rating" className='custom-input' /> */}
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-4" controlId="validationCustom01">
                <Form.Label className="custom-lable">Review</Form.Label>
                <Form.Control
                  required
                  as="textarea"
                  rows={5}
                  onChange={(e) => setReview_text(e.target.value)}
                  placeholder="Enter your review here..."
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="modal-btn">
              <button
                href="#"
                className="btn Active-bttn"
                type="submit"
                onClick={reviewBooking}
              >
                Save
              </button>
              <button
                href="#"
                className="btn Cancel-bttn"
                onClick={handleClose9}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show10}
        onHide={handleClose10}
        centered
        className="modal-center"
      >
        <Modal.Header closeButton>
          <Modal.Title>Filter data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <label className="form-label">Search Date</label>

            <div className="col-md-8">
              <div className="date-picker">
                <Form.Group
                  className="booking-custom-lable"
                  controlId="formBasicEmail"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <DateRangePicker
                        onChange={(item) => {
                          setSdate(item.selection.startDate);
                          setEdate(item.selection.endDate);
                          setDates([item.selection]);
                          setDatetype("custom");
                        }}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        // months={2}
                        ranges={dates}
                        direction="horizontal"
                      />
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>

            {/* <div className="col-md-4"> */}
            <div className="date-picker">
              <Form.Group
                className="booking-custom-lable"
                controlId="formBasicEmail"
              >
                {loadingsppiner ? (
                  <Button className="resize_btn btn" disabled>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </Button>
                ) : (
                  <div className="toggle_btn">
                    <button
                      className="resize_btn btn"
                      onClick={() => {
                        handleButtonClick();
                      }}
                    >
                      <div className="btn-text">Submit</div>
                    </button>
                  </div>
                )}
              </Form.Group>
            </div>
            {/* </div> */}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show12}
        onHide={handleClose12}
        centered
        className="modal-center reschedule-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Reschedule Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              {/* Date Picker */}
              <Form.Group className="booking-custom-lable mb-3">
                <Form.Label>Select Date</Form.Label>
                <div className="position-relative">
                  <DatePicker
                    selected={selectedDate ? new Date(selectedDate + 'T00:00:00') : null}
                    onChange={(date) => {
                      // Format date using local date components to avoid timezone issues
                      const year = date.getFullYear();
                      const month = String(date.getMonth() + 1).padStart(2, '0');
                      const day = String(date.getDate()).padStart(2, '0');
                      const formattedDate = `${year}-${month}-${day}`;
                      setSelectedDate(formattedDate);
                    }}
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date()}
                    className="form-control booking-custom-input"
                    placeholderText="Select a date"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                  />
                  <BsCalendar3
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#6c757d",
                    }}
                  />
                </div>
              </Form.Group>

              {/* Shift Timing */}
              {singalbookingData.length > 0 &&
              (singalbookingData[0].service_id == "6" ||
                singalbookingData[0].service_id == "8") ? null : (
                <Form.Group className="booking-custom-lable mb-3">
                  <Form.Label>Shift Timing</Form.Label>
                  <div
                    className="time-list"
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(250px, 1fr))",
                      gap: "1rem",
                    }}
                  >
                    <Button
                      className={`time-btn h-auto w-100 ${
                        selectedShift === "morning" ? "active" : ""
                      }`}
                      onClick={() => {
                        setSelectedShift("morning");
                        setSelectedTimeSlot(null);
                        setRescheduleBookingTime(""); // Clear booking time when shift changes
                        setValidationError("");
                      }}
                    >
                      <div className="time-btn-inner">
                        <div className="time-btn-inner-title d-flex flex-column">
                          <div className="time-btn-inner-title-text">
                            Morning
                          </div>
                          <div className="time-btn-inner-title-text">
                            8:00 AM - 11:00 AM
                          </div>
                        </div>
                      </div>
                    </Button>
                    <Button
                      className={`time-btn h-auto w-100 ${
                        selectedShift === "afternoon" ? "active" : ""
                      }`}
                      onClick={() => {
                        setSelectedShift("afternoon");
                        setSelectedTimeSlot(null);
                        setRescheduleBookingTime(""); // Clear booking time when shift changes
                        setValidationError("");
                      }}
                    >
                      <div className="time-btn-inner">
                        <div className="time-btn-inner-title d-flex flex-column">
                          <div className="time-btn-inner-title-text">
                            Afternoon
                          </div>
                          <div className="time-btn-inner-title-text">
                            12:00 PM - 5:00 PM
                          </div>
                        </div>
                      </div>
                    </Button>
                  </div>
                </Form.Group>
              )}

              {/* All Technicians Section */}
              {selectedShift && (
                <Form.Group className="booking-custom-lable mb-3">
                  <Form.Label>Technician</Form.Label>
                  <div
                    className="text-muted mt-1"
                    style={{
                      fontSize: "12px",
                      color: "#ccc",
                      fontWeight: "500",
                      lineHeight: "1.4",
                      paddingBottom: "20px",
                    }}
                  >
                    Availability reflects when a technician can begin your
                    service. If you prefer a different time, please note it in
                    the special requests. For cleans needing extra time, we may
                    adjust or add technicians to ensure your service is
                    completed to Green Frog standards.
                  </div>

                  {/* Display all technicians */}
                  {staffList && staffList.length > 0 && (
                    <div
                      className="technician-list"
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(180px, 1fr))",
                        gap: "0.75rem",
                        marginBottom: "1rem",
                      }}
                    >
                      {staffList.map((staff) => {
                        const staffId = staff.value;
                        const staffName = staff.label;
                        const timeSlots =
                          selectedShift === "morning"
                            ? availableMorningTime[staffId] || []
                            : availableAfternoonTime[staffId] || [];
                        const hasSlots = timeSlots.length > 0;
                        const isSelected = selectedSatff === staffId || selectedSatff == staffId;

                        return (
                          <Button
                            key={staffId}
                            variant="outline-primary"
                            className={`time-slot-btn ${
                              isSelected ? "active" : ""
                            } ${!hasSlots ? "no-slots" : ""}`}
                            onClick={() => {
                              setValidationError("");
                              setSelectedTimeSlot(null);
                              
                              // Clear the ref since user is manually selecting a technician
                              staffSelectedFromBooking.current = null;

                              // Check if this is Breann and hasCats is true (similar to Step02.js)
                              const isBreann = staffName.includes("Breann");
                              const shouldAddAsRequested = isBreann && hasCats;

                              if (hasSlots && !shouldAddAsRequested) {
                                // Technician has slots and it's not Breann+cat - select normally
                                setSelectedSatff(staffId);
                                // Auto-select first available slot
                                if (timeSlots.length > 0) {
                                  setSelectedTimeSlot(timeSlots[0]);
                                }
                                // Remove "Requested Technician" from special client requests when selecting a technician with slots
                                // Preserve Booking Time and Instructions format
                                const currentRequest = specialClientRequests || "";
                                if (currentRequest) {
                                  let cleanedRequest = currentRequest.replace(
                                    /Requested Technician\s*:\s*.+?(?:\r\n|\n|$)/gi,
                                    ""
                                  ).trim();
                                  // Ensure Booking Time and Instructions are preserved
                                  if (!cleanedRequest.includes("Booking Time :")) {
                                    cleanedRequest = `Booking Time : ${rescheduleBookingTime || ""}\nInstructions : ${rescheduleClientNotes || ""}` + (cleanedRequest ? `\n${cleanedRequest}` : "");
                                  }
                                  setSpecialClientRequests(cleanedRequest);
                                }
                              } else {
                                console.log("Technician has no slots or is Breann+cat, adding to request");
                                // Technician has no slots OR it's Breann+cat - add to request
                                setSelectedSatff(staffId);
                                const requestedTechText = `Requested Technician: ${staffName}`;
                                
                                // Check if already in request (case-insensitive)
                                const currentRequest = specialClientRequests || "";
                                const hasRequestedTech = /Requested Technician\s*:/i.test(currentRequest);
                                
                                // Ensure Booking Time and Instructions format is preserved
                                let baseRequest = currentRequest;
                                if (!baseRequest.includes("Booking Time :")) {
                                  baseRequest = `Booking Time : ${rescheduleBookingTime || ""}\nInstructions : ${rescheduleClientNotes || ""}`;
                                }
                                
                                if (!hasRequestedTech) {
                                  // Add to request if not already present
                                  const updatedRequest = baseRequest
                                    ? `${baseRequest}\n${requestedTechText}`
                                    : requestedTechText;
                                  setSpecialClientRequests(updatedRequest);
                                } else {
                                  // Replace existing "Requested Technician" line
                                  const updatedRequest = baseRequest.replace(
                                    /Requested Technician\s*:\s*.+?(?:\r\n|\n|$)/i,
                                    `${requestedTechText}\n`
                                  );
                                  setSpecialClientRequests(updatedRequest.trim());
                                }
                              }
                            }}
                            // style={{
                            //   opacity: hasSlots ? 1 : 0.7,
                            // }}
                          >
                            {staffName} 
                            {/* {!hasSlots && "(No Slots)"} */}
                          </Button>
                        );
                      })}
                    </div>
                  )}

                  {/* Time Slots Display */}
                  {/* {(selectedShift === "morning"
                    ? Object.values(availableMorningTime).flat().length
                    : Object.values(availableAfternoonTime).flat().length) === 0 ? (
                    <div
                      style={{
                        padding: "10px 0",
                        color: "red",
                        fontWeight: "600",
                      }}
                    >
                      NO SLOT AVAILABLE
                    </div>
                  ) : (
                    <div
                      className="time-slot-list"
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(180px, 1fr))",
                        gap: "0.75rem",
                      }}
                    >
                      {(selectedShift === "morning"
                        ? availableSlots
                        : availableSlots
                      ).map((slot, index) => (
                        <Button
                          key={index}
                          variant="outline-primary"
                          className={`time-slot-btn ${
                            selectedTimeSlot === slot ? "active" : ""
                          }`}
                          onClick={() => {
                            setSelectedTimeSlot(slot);
                            setValidationError(""); // Clear error when slot is selected

                            // Extract staff_id from the selected slot
                            const timeSlots =
                              selectedShift === "morning"
                                ? availableMorningTime
                                : availableAfternoonTime;
                            for (const [staffId, slots] of Object.entries(
                              timeSlots
                            )) {
                              if (slots.includes(slot)) {
                                setSelectedSatff(staffId);
                                break;
                              }
                            }
                          }}
                        >
                          {slot}
                        </Button>
                      ))}
                    </div>
                  )} */}
                </Form.Group>
              )}

              {/* <Form.Group className="booking-custom-lable mb-3">
                <Form.Label className="fw-semibold">
                  Preferred Technician
                </Form.Label>

                <div className="d-flex gap-4 ">
                  <Form.Check
                    type="checkbox"
                    id="preferredTechYes"
                    label="Yes"
                    checked={preferredTech === "yes"}
                    onChange={() =>
                      setPreferredTech(preferredTech === "yes" ? "" : "yes")
                    }
                  />

                  <Form.Check
                    type="checkbox"
                    id="preferredTechNo"
                    label="No"
                    checked={preferredTech === "no"}
                    onChange={() =>
                      setPreferredTech(preferredTech === "no" ? "" : "no")
                    }
                  />
                </div>
              </Form.Group> */}

              <div className="row Service-details-box-inner-title">
                <div className="col-md-12 mb-3">
                  <Form.Label>Special Client Requests</Form.Label>
                  <Form.Group className="booking-custom-lable mb-3">
                    <Form.Label>
                      Booking Time: <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Select
                      value={rescheduleBookingTime || ""}
                      onChange={(e) => {
                        setRescheduleBookingTime(e.target.value);
                        setValidationError("");
                      }}
                      required
                      className="booking-custom-input p-2"
                      style={{
                        border: "1px solid #ccc",
                      }}
                    >
                      <option value="">Select time</option>
                      {timeSlots.map((slot) => (
                        <option key={slot.value} value={slot.value}>
                          {slot.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="booking-custom-lable mb-3">
                    <Form.Label>Do you have pets?</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        type="checkbox"
                        id="pets-cats-reschedule"
                        label="Cat"
                        style={{ color: "#6c7581", fontWeight: "500" }}
                        checked={hasCats}
                        onChange={(e) => {
                          setHasCats(e.target.checked);
                        }}
                      />
                      <Form.Check
                        inline
                        type="checkbox"
                        id="pets-dogs-reschedule"
                        label="Dog"
                        style={{ color: "#6c7581", fontWeight: "500" }}
                        checked={hasDogs}
                        onChange={(e) => {
                          setHasDogs(e.target.checked);
                        }}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group className="booking-custom-lable">
                    <Form.Label>
                      Appointment Instructions: <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={rescheduleClientNotes}
                      onChange={(e) => {
                        setRescheduleClientNotes(e.target.value);
                        setValidationError("");
                      }}
                      placeholder="Instructions for parking, access details and notes for the technician"
                      required
                      className="booking-custom-input p-2"
                      style={{
                        height: "150px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </Form.Group>
                  <div
                    className="text-muted mt-1"
                    style={{
                      fontSize: "12px",
                      color: "#ccc",
                      fontWeight: "500",
                      lineHeight: "1.4",
                    }}
                  >
                    Please Share your ideal time window (e.g., "10–11 AM"), and
                    any important instructions—access, parking, gate codes, pet
                    notes, or a backup contact number.
                  </div>
                </div>
              </div>

              {/* Validation Error Display */}
              {validationError && (
                <div
                  className="alert alert-danger d-flex align-items-center"
                  role="alert"
                  style={{
                    marginBottom: "15px",
                    padding: "10px 15px",
                    fontSize: "14px",
                    borderRadius: "5px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-exclamation-circle-fill me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                  </svg>
                  <div>{validationError}</div>
                </div>
              )}

            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
              <div className="date-picker d-flex justify-content-end">
                <div className="toggle_btn">
                  <button className="resize_btn btn" onClick={handleSubmit}>
                    <div className="btn-text">
                      {" "}
                      {isLoadingschedule ? (
                        <Spinner animation="border" />
                      ) : (
                        "Submit"
                      )}
                    </div>
                  </button>
                </div>
              </div>
        </Modal.Footer>
        <style>
          {`
                    .time-btn {
                        border: 1px solid #ccc !important;
                    }
                    .time-btn.active {
                        background-color: #77b41a;
                        color: white;
                    }

                    .time-slot-btn.active {
                        background-color: #77b41a;
                        color: white;
                        border-color: #77b41a;
                    }

                    .time-slot-btn {
                        color: #77b41a;
                        border-color: #77b41a;
                    }

                    .time-slot-btn:hover {
                        background-color: #77b41a;
                        color: white;
                        border-color: #77b41a;
                    }

                    .react-datepicker-wrapper {
                        width: 100%;
                    }

                    .react-datepicker__input-container {
                        width: 100%;
                    }
                    .reschedule-modal .modal-body {
                      max-height: 70vh;
                      overflow-y: auto;
                    }
                    `}
        </style>
      </Modal>

      <div className="App">
        <Header />
        <Topnavigation />
        <Herosection />
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <div className="bg-custom">
            <div className="dashboard-custom-container hero-bottom">
              <div className="hero-bottom-margin">
                <div className="dashboard-tab-list">
                  <Nav variant="pills">
                    <Nav.Item>
                      <Nav.Link eventKey="first" className="Booking-tab me-4">
                        Booking
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="Payment"
                        className="Booking-tab me-4"
                        onClick={getPayments}
                      >
                        Payment Settings
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="Transaction"
                        className="Booking-tab"
                        onClick={getinvoice}
                      >
                        Invoices
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="hide-desktop show-mobile">
                      <Nav.Link eventKey="Profile" className="Booking-tab ms-4">
                        Profile
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-custom-container dflt-mt-top">
            <div className="row">
              <div className="col-xxl-3 col-xl-4">
                <Profile />
              </div>
              <div className="col-xxl-9 col-xl-8 col-md-12 text-start">
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <div className="col-12 d-flex justify-content-end mb-3">
                      <div class="toggle_btn">
                        {loadingsppiner ? (
                          <Button className="resize_btn btn" disabled>
                            <Spinner
                              as="span"
                              animation="grow"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                            <span className="loading-text"> ...Loading</span>
                          </Button>
                        ) : (
                          <button
                            class="resize_btn filter_btn btn"
                            onClick={handleShow10}
                          >
                            <div class="btn-text">Booking Filter</div>
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="booking-list">
                      <nav>
                        <ul>
                          {bookings.length > 0 ? (
                            bookings.map((booking, index) => {
                              const bookingDateTime = new Date(
                                booking.booking_date_time
                              );
                              const currentDateTime = new Date(defaulttimezone);
                              return (
                                <li key={booking.order_id}>
                                  <div className="bookings-service-listed">
                                    <div className="booking-list-number">
                                      <h1>{index + 1}</h1>
                                      <div className="booking-list-content">
                                        <div className="order-id">
                                          <h6>{`Order ID: ${booking.order_id}`}</h6>
                                        </div>
                                        {/* <div className='order-type' style={{border: `2px solid ${booking.color}`}}> */}
                                        <div className="order-type">
                                          <h4>{booking.title}</h4>
                                        </div>
                                        <div className="order-text">
                                          <p>AMOUNT : {`$${booking.amount}`}</p>
                                          <p>
                                            Boooking Date Time :{" "}
                                            {`${getdatetime(
                                              booking.booking_date_time,
                                              booking.request
                                            )}`}
                                          </p>
                                          {getPetInfo(booking.request) && (
                                            <p>
                                              Pets At Home : {getPetInfo(booking.request)}
                                            </p>
                                          )}
                                        </div>
                                        <div className="order-text">
                                          {(() => {
                                            // Check if "Requested Technician" is in the request
                                            const requestedTech =
                                              getRequestedTechnician(
                                                booking.request
                                              );

                                            const label = requestedTech
                                              ? "Requested Technician"
                                              : "Technician";

                                            const value = requestedTech
                                              ? requestedTech
                                              : booking.staff_ids === "115"
                                              ? "Unassigned"
                                              : booking.staff_name
                                                  .replace(/\s*,\s*/g, ",")
                                                  .replace(/^,|,$/g, "");

                                            return (
                                              <span>
                                                {label} :{" "}
                                                <strong>{value}</strong>
                                              </span>
                                            );
                                          })()}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="booking-actions">
                                      <button
                                        href="#"
                                        style={{
                                          display: "none",
                                        }}
                                        className="btn mb-3 Active-bttn"
                                        onClick={(e) => {
                                          handleShow5();
                                          reschedulebooking(booking);
                                        }}
                                      >
                                        Modify Booking
                                      </button>
                                      {booking.booking_status === "CC" ? (
                                        <p>Canceled</p>
                                      ) : (
                                        <>
                                          {bookingDateTime > currentDateTime &&
                                            booking.booking_status !== "CO" && (
                                              <button
                                                href="#"
                                                className="btn Cancel-bttn mb-2"
                                                onClick={() => {
                                                  setOrderId(booking.order_id);
                                                  setBookingDateTime(
                                                    booking.booking_date_time
                                                  );
                                                  checkTimeAndAlert(
                                                    booking.booking_date_time
                                                  );
                                                  sendEmailToSupport(
                                                    booking.order_id
                                                  );
                                                }}
                                              >
                                                {appicall &&
                                                orderid === booking.order_id ? (
                                                  <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    id={booking.order_id}
                                                  />
                                                ) : (
                                                  "Cancel Booking"
                                                )}
                                              </button>
                                            )}

                                          {/* <Link to={`booking?order_id=${booking.order_id}`}>
                                                                                                <button href="#" className="btn Cancel-bttn">
                                                                                                    Modify Booking
                                                                                                </button>
                                                                                            </Link> */}
                                          {/* <Link> */}
                                          <button
                                            href="#"
                                            className="btn Cancel-bttn"
                                            onClick={
                                              //handleShow12
                                              () => {
                                                //handleShow12();
                                                reschedulebooking(booking);
                                              }
                                            }
                                          >
                                            Reschedule Booking
                                          </button>
                                          {/* </Link> */}
                                        </>
                                      )}
                                      {booking.booking_status === "CO" &&
                                        booking.review_status === "0" && (
                                          <button
                                            href="#"
                                            className="btn Cancel-bttn"
                                            onClick={() => {
                                              setOrderId(booking.order_id);
                                              setBookingDateTime(
                                                booking.booking_date_time
                                              );
                                              setStaff_id(booking.staff_ids);
                                              setBookingStaffName(
                                                booking.staff_name
                                              );
                                              setBookingAmount(booking.amount);

                                              // reviewBooking(booking);
                                              handleShow9();
                                            }}
                                          >
                                            Review
                                          </button>
                                        )}
                                    </div>
                                  </div>
                                </li>
                              );
                            })
                          ) : (
                            // <p>No bookings available.</p>
                            <nav>
                              <ul
                                style={{
                                  textAlign: "center",
                                  color: "#75b317",
                                }}
                              >
                                <li>
                                  <h3>No appointment Scheduled!</h3>
                                </li>
                              </ul>
                            </nav>
                          )}
                        </ul>
                      </nav>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Payment">
                    <div className="payment-settings">
                      <div className="payment-settings-content">
                        <div className="payment-settings-content-header d-flex justify-content-beetwin align-items-center">
                          <h3>Payment Methods</h3>
                          <button
                            href="#"
                            className="btn Add-bttn ms-auto"
                            onClick={() => {
                              resetCardForm();
                              handleShow4();
                            }}
                          >
                            <span>
                              <BsPlusLg />
                            </span>{" "}
                            Add Card
                          </button>
                        </div>
                        {loadingapi ? (
                          <div className="d-flex mt-4 mb-4 justify-content-center">
                            <Roller size={50} color="#75b317" />
                          </div>
                        ) : paymentMethods.length == 0 ? (
                          <div
                            style={{
                              textAlign: "center",
                              color: "#75b317",
                              margin: "30px 0",
                            }}
                          >
                            <h3>No Payment Methods Found</h3>
                          </div>
                        ) : (
                          <>
                            <div className="payment-settings-content-body mt-4">
                              <nav>
                                <ul>
                                  <p className="select-card-text">
                                    Select default card
                                  </p>
                                  {paymentMethods &&
                                    Array.isArray(paymentMethods) &&
                                    paymentMethods.map((payment, index) => {
                                      return (
                                        <>
                                          <div className="d-flex align-items-center">
                                            <input
                                              className="form-check-input me-3"
                                              type="radio"
                                              name="cardOption"
                                              id={`cardOption${index}`}
                                              value={`cardOption${index}`}
                                              checked={
                                                defaultpaymentmethod
                                                  ? payment.id ===
                                                    defaultpaymentmethod
                                                  : index === 0
                                              }
                                              onChange={(e) => {
                                                updatepaymentdetails(
                                                  payment.id
                                                );
                                              }}
                                            />
                                            <li className="w-100">
                                              <div className="d-flex align-items-center justify-content-between flex-wrap">
                                                <div className="Payment-list-content">
                                                  <div className="Card-Name">
                                                    <h4>
                                                      {payment.person_name}
                                                    </h4>
                                                  </div>
                                                  <div className="Card-Name">
                                                    <h4>{payment.card_type}</h4>
                                                  </div>
                                                  <div className="Card-number">
                                                    <p>
                                                      {payment.card_last_four}
                                                    </p>
                                                  </div>
                                                  <div className="Card-number">
                                                    <p>
                                                      {checkCardExpiration(
                                                        payment.card_exp_datetime
                                                      )}
                                                    </p>
                                                  </div>
                                                </div>
                                                <div
                                                  className="booking-actions2"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  {/* {(!defaultpaymentmethod || payment.id === defaultpaymentmethod) && (
                                                                                                        <Badge bg="info">Default Card</Badge>
                                                                                                    )}
                                                                                                      {(!defaultpaymentmethod || payment.id !== defaultpaymentmethod) && (
                                                                                                            <div className='text-align-right'>
                                                                                                                <button className='btn Delete-bttn denger' onClick={() => deleteCard(payment.id)}>
                                                                                                                    Delete
                                                                                                                </button>
                                                                                                            </div>
                                                                                                        )} */}

                                                  {((!defaultpaymentmethod &&
                                                    index === 0) ||
                                                    payment.id ===
                                                      defaultpaymentmethod) && (
                                                    <Badge bg="info" className="mb-2">
                                                      Default Card
                                                    </Badge>
                                                  )}
                                                  <div className="text-align-right mb-2">
                                                    <button
                                                      className="btn Delete-bttn update"
                                                      onClick={() =>
                                                        handleOpenUpdateCard(
                                                          payment
                                                        )
                                                      }
                                                    >
                                                      Update
                                                    </button>
                                                  </div>
                                                  {defaultpaymentmethod === null
                                                    ? ""
                                                    : (!defaultpaymentmethod ||
                                                        payment.id !==
                                                          defaultpaymentmethod) && (
                                                        <div className="text-align-right">
                                                          <button
                                                            className="btn Delete-bttn denger"
                                                            onClick={() =>
                                                              deleteCard(
                                                                payment.id
                                                              )
                                                            }
                                                          >
                                                            Delete
                                                          </button>
                                                        </div>
                                                      )}

                                                  {/* {(!defaultpaymentmethod || payment.id !== defaultpaymentmethod) && index !== 0 && (
                                                                                                            <div className='text-align-right'>
                                                                                                                <button className='btn Delete-bttn denger' onClick={() => deleteCard(payment.id)}>
                                                                                                                    Delete
                                                                                                                </button>
                                                                                                            </div>
                                                                                                        )} */}

                                                  {/* {defaultpaymentmethod ? payment.id === defaultpaymentmethod : index > 0 && (
                                                                                                            <div className='text-align-right'>
                                                                                                                <button href="#" className='btn Delete-bttn denger' onClick={
                                                                                                                    () => {
                                                                                                                        deleteCard(payment.id);
                                                                                                                    }
                                                                                                                } >Delete</button>
                                                                                                            </div>
                                                                                                        )} */}

                                                  <div className="Card-Exp-date w-100">
                                                    <p>{`Card expires at ${getcardtype(
                                                      payment.card_exp
                                                    )}`}</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </li>
                                          </div>
                                        </>
                                      );
                                    })}
                                </ul>
                              </nav>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Transaction">
                    <div className="transaction-History">
                      <div className="transaction-History-content">
                        <div className="transaction-History-content-header mb-4">
                          <h3>Invoice Details</h3>
                        </div>
                        {loading ? (<div className="d-flex mt-4 mb-4 justify-content-center">
                            <Roller size={50} color="#75b317" />
                          </div>) : invoiceList && invoiceList.length > 0 ? (
                        <Table className="Transacrion-Table">
                          <thead>
                            <tr>
                              <th>DATE</th>
                              <th>AMOUNT</th>
                              {/* <th>DETAILS</th> */}
                              <th>STATUS</th>
                              <th style={{ display: "none" }}>DOWNLOAD</th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoiceList &&
                              invoiceList.map((invoice) => {
                                return (
                                  <tr>
                                    <td>
                                      {getformeteddate(invoice.created_at)}
                                    </td>
                                    <td>
                                      <ul>
                                        {(() => {
                                          const cleaningTotal =
                                            invoice.meta.lineItems
                                              .filter(
                                                (item) =>
                                                  item.item
                                                    ?.toLowerCase()
                                                    .includes("cleaning") ||
                                                  item.details
                                                    ?.toLowerCase()
                                                    .includes("fee") ||
                                                  item.details
                                                    ?.toLowerCase()
                                                    .includes("satish")
                                              )
                                              .reduce(
                                                (sum, item) =>
                                                  sum +
                                                  (parseFloat(item.price) ||
                                                    0) *
                                                    (parseFloat(
                                                      item.quantity
                                                    ) || 1),
                                                0
                                              );

                                          return (
                                            cleaningTotal > 0 && (
                                              <li>
                                                Cleaning = $
                                                {Math.round(cleaningTotal)}
                                              </li>
                                            )
                                          );
                                        })()}

                                        {(() => {
                                          const discountTotal =
                                            invoice.meta.lineItems
                                              .filter(
                                                (item) =>
                                                  item.item
                                                    ?.toLowerCase()
                                                    .includes("discount") ||
                                                  parseFloat(item.price) < 0
                                              )
                                              .reduce(
                                                (sum, item) =>
                                                  sum +
                                                  (parseFloat(item.price) ||
                                                    0) *
                                                    (parseFloat(
                                                      item.quantity
                                                    ) || 1),
                                                0
                                              );

                                          return (
                                            discountTotal !== 0 && (
                                              <li>
                                                Discount = $
                                                {Math.round(discountTotal)}
                                              </li>
                                            )
                                          );
                                        })()}

                                        {(() => {
                                          const tipsTotal =
                                            invoice.meta.lineItems
                                              .filter((item) =>
                                                item.item
                                                  ?.toLowerCase()
                                                  .includes("tip")
                                              )
                                              .reduce(
                                                (sum, item) =>
                                                  sum +
                                                  (parseFloat(item.price) ||
                                                    0) *
                                                    (parseFloat(
                                                      item.quantity
                                                    ) || 1),
                                                0
                                              );

                                          return (
                                            tipsTotal > 0 && (
                                              <li>
                                                Tips = ${Math.round(tipsTotal)}
                                              </li>
                                            )
                                          );
                                        })()}

                                        <li>
                                          Total = ${Math.round(invoice.total)}
                                        </li>
                                      </ul>
                                    </td>

                                    {/* <td className='Price-bold'>{`$${invoice.total}`}</td> */}
                                    {/* <td>{
                                                                            invoice.status == 'PAID' ? <span className='paid'>Paid</span> : <Button className="Enable-Active-bttn"
                                                                                onClick={() => getpaymentCards(invoice.id, invoice.total)}>PAY NOM</Button>
                                                                                
                                                                        }</td> */}
                                    <td>
                                      {invoice.total !== 0 &&
                                        (invoice.status === "DRAFT" ||
                                        invoice.status === "PENDING" ? (
                                          <Button
                                            className="Enable-Active-bttn invoice-list-btn"
                                            onClick={() =>
                                              getpaymentCards(
                                                invoice.id,
                                                invoice.total
                                              )
                                            }
                                          >
                                            PAY Now
                                          </Button>
                                        ) : (
                                          invoice.status
                                        ))}
                                    </td>
                                    <td style={{ display: "none" }}>
                                      <button
                                        className="invoice-download"
                                        onClick={() => {
                                          downloadInvoice(invoice.id);
                                        }}
                                      >
                                        Invoice {invoice.created_at}
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </Table>) : 
                        <div
                          style={{
                            textAlign: "center",
                            color: "#75b317",
                          }}
                        >
                          <h3>No Invoice Found</h3>
                        </div>}
                        {/* {loading ? (
                          <Button
                            className="btn btn-sm add-user-btn btn btn-primary"
                            disabled
                          >
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          </Button>
                        ) : invoiceList ? (
                          <button
                            href="#"
                            class="btn btn-sm add-user-btn btn btn-primary"
                            style={{ display: "none" }}
                          >
                            Load more
                          </button>
                        ) : null} */}
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane
                    eventKey="Profile"
                    className="hide-desktop show-mobile"
                  >
                    <Profile2 />
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </Tab.Container>
      </div>
      <NotificationContainer />
    </>
  );
}

function getdatetime(booking_date_time, request = "") {
  const date = new Date(booking_date_time);

  // Get individual parts
  const options = { month: "long" };
  const month = date.toLocaleString("en-US", options);
  const day = date.getDate();
  const year = date.getFullYear();

  let hour, minutes, timeStr;

  // Check if there's a booking time in the request
  if (request) {
    const bookingTimeMatch = request.match(/Booking Time\s*:\s*(.+?)(?:\r\n|\n|$)/i);
    if (bookingTimeMatch && bookingTimeMatch[1]) {
      const bookingTime = bookingTimeMatch[1].trim();
      // Parse time in format HH:mm (e.g., "08:00", "14:30")
      const timeParts = bookingTime.split(':');
      if (timeParts.length >= 2) {
        hour = parseInt(timeParts[0], 10);
        minutes = parseInt(timeParts[1], 10);
        
        // Validate hour and minutes
        if (!isNaN(hour) && !isNaN(minutes) && hour >= 0 && hour < 24 && minutes >= 0 && minutes < 60) {
          const ampm = hour >= 12 ? "pm" : "am";
          let displayHour = hour % 12;
          displayHour = displayHour ? displayHour : 12; // convert 0 to 12

          timeStr =
            minutes === 0
              ? `${displayHour}${ampm}`
              : `${displayHour}:${minutes.toString().padStart(2, "0")}${ampm}`;

          return `${month} ${day}, ${year} @ ${timeStr}`;
        }
      }
    }
  }

  // Fallback to using time from booking_date_time
  hour = date.getHours();
  minutes = date.getMinutes();
  const ampm = hour >= 12 ? "pm" : "am";

  hour = hour % 12;
  hour = hour ? hour : 12; // convert 0 to 12

  timeStr =
    minutes === 0
      ? `${hour}${ampm}`
      : `${hour}:${minutes.toString().padStart(2, "0")}${ampm}`;

  return `${month} ${day}, ${year} @ ${timeStr}`;
}

function checkCardExpiration(card_exp_datetime) {
  const thresholdDays = 90;

  // Get the current date and time
  const now = new Date();
  const expDate = new Date(card_exp_datetime);
  const thresholdDate = new Date(
    now.getTime() + thresholdDays * 24 * 60 * 60 * 1000
  );

  if (expDate < now) {
    return "Your Card is Expired";
  } else if (expDate <= thresholdDate) {
    return "Your Card is About to expire";
  } else {
    return "";
  }
}

function getRequestedTechnician(request) {
  if (!request) return null;
  
  // Check if "Requested Technician" exists in the request
  const requestedTechMatch = request.match(/Requested Technician\s*:\s*(.+?)(?:\r\n|\n|$)/i);
  
  if (requestedTechMatch && requestedTechMatch[1]) {
    return requestedTechMatch[1].trim();
  }
  
  return null;
}

function removeRequestedTechnicianFromRequest(request) {
  if (!request) return "";
  
  // Remove "Requested Technician: [Name]" line from the request
  const cleanedRequest = request.replace(/Requested Technician\s*:\s*.+?(?:\r\n|\n|$)/gi, "").trim();
  
  return cleanedRequest;
}

function parseSpecialClientRequests(request) {
  if (!request) return { bookingTime: "", instructions: "", hasCats: false, hasDogs: false };
  
  // Extract Booking Time
  const bookingTimeMatch = request.match(/Booking Time\s*:\s*(.+?)(?:\r\n|\n|$)/i);
  const bookingTime = bookingTimeMatch && bookingTimeMatch[1] ? bookingTimeMatch[1].trim() : "";
  
  // Extract Instructions
  const instructionsMatch = request.match(/Instructions\s*:\s*([\s\S]*?)(?:\r\n|\n|(?:Pets at Home|Requested Technician)|$)/i);
  const instructions = instructionsMatch && instructionsMatch[1] ? instructionsMatch[1].trim() : "";
  
  // Extract Pets information
  const petsMatch = request.match(/Pets at Home\s*:\s*(.+?)(?:\r\n|\n|$)/i);
  let hasCats = false;
  let hasDogs = false;
  
  if (petsMatch && petsMatch[1]) {
    const petsValue = petsMatch[1].trim().toLowerCase();
    if (petsValue.includes("dog and cat") || petsValue.includes("cat and dog")) {
      hasCats = true;
      hasDogs = true;
    } else if (petsValue.includes("cat")) {
      hasCats = true;
    } else if (petsValue.includes("dog")) {
      hasDogs = true;
    }
  }
  
  return { bookingTime, instructions, hasCats, hasDogs };
}

function getPetInfo(request) {
  if (!request) return null;

  // Check if "Pet Info" exists in the request
  const petInfoMatch = request.match(/Pets at Home\s*:\s*(.+?)(?:\r\n|\n|$)/i);

  if (petInfoMatch && petInfoMatch[1]) {
    return petInfoMatch[1].trim();
  }

  return null;
}

export default Dashboard;
